// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Lnb","up":"e_Mnb","down":"e_Nnb","percent":"e_Onb","percentVal":"e_Pnb","title":"e_Qnb","tags":"e_Rnb","textBadge":"e_Snb"};